import styled from 'styled-components';

import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  position: relative;
  width: 261px;
  padding: 16px 16px 8px;
  z-index: 10;
`;

interface ILabel {
  disabled?: boolean;
}

export const Label = styled.div<ILabel>`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 0;
  color: ${({ disabled }) => (disabled ? '#C1C4D6' : '#474d66')};
  align-items: center;

  &.block {
    color: #ea1212;
  }
`;

export const Content = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const Icon = styled.img`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
`;

interface ItemProps {
  isDisabled?: boolean;
}

export const Item = styled.div<ItemProps>`
  display: flex;
  align-items: center;
  height: 38px;
  justify-content: flex-start;
  cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};
  position: relative;
  color: ${beam.font.primary};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : '1')};
  gap: 8px;
  align-items: center;
`;

export const Block = styled.div`
  background: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  cursor: auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  margin-bottom: 16px;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 16px;
  font-weight: 600;
`;

export const Close = styled.button`
  cursor: pointer;
  border: 0;
  background-color: transparent;
  border-radius: 8px;
  padding-top: 6px;
  width: 32px;
  height: 32px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const IconsWrapper = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
`;
